import styled from '@emotion/styled/macro';
import { keyframes } from '@emotion/react';

export const RevealContainer = styled.div`
    z-index: 100;
`;

const bounce = keyframes`
    from, 0%, to 100% {
        transform: scale(1);
    }
    
    to, 100% {
        transform: scale(1.1);
    }
  `;

export const RevealAnimation = styled.div`
    animation-delay: 0.25s;
    animation: ${bounce} 1.5s ease-in alternate;
    animation-fill-mode: forwards;
`;

export const ConfettiContainer = styled.div`
    position: relative;
    left: 50%;
    top: -55px;
    z-index: -1;
`;
